/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { AuthProvider } from '../../../providers';
import { Router, ActivatedRoute} from '@angular/router';
import { Subscription } from 'rxjs';
import { CrmAlertComponent } from '../../fields';
import { LogService } from 'src/app/services';


@Component({
  selector: 'page-recovery',
  templateUrl: 'recovery.page.html',
  styleUrls: ['recovery.page.scss']
})

export class RecoveryPage implements OnInit, OnDestroy {

  @ViewChild('alert') alert: CrmAlertComponent;

  recoveryForm: FormGroup;
  isCodeValid = false;
  code: string;
  user: any;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authProvider: AuthProvider,
    private router: Router,
    private logService : LogService
  ) {
    this.recoveryForm = this.fb.group({
      USER_PASSWORD: [null, Validators.compose([Validators.required, Validators.pattern('^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])[\\w~@#$%^&*+=`<>|{}:=’;!.?\\"()\\[\\]\\/-]{12,}$')])],
      USER_CONFIRM_PASSWORD: [null, Validators.compose([Validators.required, this.compareValidator('USER_PASSWORD')])]
    });
  }

  compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }

      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }

      return controlToCompare && controlToCompare.value !== c.value ? { 'compare': true } : null;
    };

  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.code = this.route.snapshot.queryParams['code'];

    if (!this.code) {
      this.isCodeValid = false;
    } else {
      this.isCodeValid = true;
    }

  }

  onSubmit(): void {

    this.alert.hide();

    if (this.recoveryForm.valid) {
      const password = this.recoveryForm.value.USER_PASSWORD;
      this.authProvider.completeReset(this.code, password)
        .subscribe(response => {
          if (response.success) {
            this.alert.showSuccess('You successfully changed the password.');
            this.recoveryForm.reset();
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 3000);
          } else {
            this.alert.show(response.error);
          }
        }, err => {
          this.logService.error(err);
        });
    }
  }
}
